//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SchoolInputItem extends ItemBase {
    Captcha: string | null = null;
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    IsMultiTeacher: boolean = false;
    LastName: string | null = null;
    Password: string | null = null;
    ReferralPartnerCode: string | null = null;
    ReferralSchoolCode: string | null = null;
    SchoolName: string | null = null;
    Country: string | null = null;

    constructor(initializer?: Partial<SchoolInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolInputItem";
}
